module.exports = __webpack_public_path__ + "img/20250821_1.4e23bbcd.png";